import { useParams } from "react-router-dom";
import { getIntegrationMeta } from "./integrationRegistry.js";
import { GenericDashboard } from "./components/GenericDashboard.js";

export const IntegrationDashboardPage = () => {
  const { integrationId } = useParams();
  if (!integrationId) throw new Error("integrationId is missing");

  const meta = getIntegrationMeta(integrationId);
  const DashboardComponent = meta.Dashboard;

  if (DashboardComponent) {
    return <DashboardComponent integrationId={integrationId} />;
  }

  return <GenericDashboard integrationId={integrationId} />;
};
